import $ from "jquery";
import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import "../components/init.js"
import BrainTreeController from "../components/controllers/brain_tree_controller.js"
require("stylesheets/portal.scss")

// https://stackoverflow.com/questions/37738732/jquery-3-0-url-indexof-error
// jquery 3.x call load function different. This is fallback for legacy code to working
jQuery.fn.load = function(callback){ $(window).on("load", callback) };

Turbo.session.drive = false // make Turbo Drive opt-in - you need to use data-turbo="true" per-element
Rails.start()
ActiveStorage.start()

window.jQuery = jQuery;
window.$ = $;
window.BrainTreeController = BrainTreeController
